import { gsap, ScrollTrigger } from '../utils/gsap-config.js';
import { initTreeParallaxCSS } from './tree-parallax.js';

export function initHeroAnimations() {
  // document.addEventListener('DOMContentLoaded', () => {
  //   setTimeout(() => {
  //     heroTimeline.play();
  //   }, 300);
  // });

  // Tree section animation with CSS-based parallax
  const treeContainer = document.querySelector('#tree-container');
  if (treeContainer) {
    // Main entrance animation - slide up from bottom
    gsap.fromTo(treeContainer, 
      { 
        opacity: 0.8,
        y: 50
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: treeContainer,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        }
      }
    );

    initTreeParallaxCSS(treeContainer);
  }

  // ScrollTrigger.create({
  //   trigger: 'section',
  //   start: 'top top',
  //   end: 'bottom top',
  //   scrub: 1,
  //   onUpdate: (self) => {
  //     const progress = self.progress;
      
  //     gsap.set('section h1', {
  //       y: progress * -50,
  //       opacity: 1 - progress * 0.5
  //     });
      
  //     gsap.set('section p', {
  //       y: progress * -30,
  //       opacity: 1 - progress * 0.3
  //     });
  //   }
  // });

  // return heroTimeline;
} 